import { Component } from '@angular/core';
import { Form, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ShiftsService } from 'app/services/shifts.service';

@Component({
  selector: 'app-turnos-edit-update',
  templateUrl: './turnos-edit-update.component.html',
  styleUrls: ['./turnos-edit-update.component.css']
})
export class TurnosEditUpdateComponent {

  form: FormGroup;
  idTurno: number;

  constructor(
    private fb: FormBuilder,
    private turnoService: ShiftsService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    // verificamos si ingresa un id por parametro
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.idTurno = parseInt(id, 10);
      this.getTurno(this.idTurno);
    }
    this.form = this.fb.group({
      name: ['', Validators.required],
      startTime: ['', Validators.required],
      endTime: ['', Validators.required],
    });
  }

  getTurno(id: number) {

    this.turnoService.getTurno(id).subscribe(
      (resp: any) => {
        this.form.patchValue(resp);
      },
      (error) => {
        console.error(error);
      }
    );
  }

  updateTurno() {
    const turno = this.form.getRawValue();
    this.turnoService.updateTurno(this.idTurno, turno).subscribe(
      (resp: any) => {
        this.router.navigate(['/configurar/turnos']);
      },
      (error) => {
        console.error(error);
      }
    );
  }

  guardar() {
    if (this.idTurno) {
      this.updateTurno();
    } else {
      this.saveTurno();
    }
  }

  saveTurno() {
    const turno = this.form.getRawValue();
    this.turnoService.saveTurno(turno).subscribe(
      (resp: any) => {
        this.router.navigate(['/configurar/turnos']);
      },
      (error) => {
        console.error(error);
      });
  }

}
